module.exports = __webpack_public_path__ + "img/mobile-screenshots-update.7ecb74fa.png";